export default __webpack_public_path__ + "static/media/bet.af143762.mp3";